import Modal from "@/components/common/Modal";
import { useCurrency } from "@/context/CurrencyContext";
import { useState } from "react";
import ProfitAndLossRawData from "../ProfitAndLossRawData";
import FoldOutButton from "@/components/ui/ButtonFoldOut";
import { Body0, Body1, Body1Muted } from "@/components/ui/Typography";
import { useProfitAndLossVoucherRowsRange } from "@/hooks/use-profit-and-loss-voucher-rows";

type YM = { year: number; month: number };
export type RangeFilter = { from: YM; to: YM };

interface Props {
  node: any;
  level: number;
  keyPath: (string | number)[];
  expanded: Record<string, boolean>;
  toggle: (key: string) => void;
  renderRow: (n: any, lvl: number, kp: (string | number)[]) => JSX.Element;
  clientId: string;
  connectionId: string;
  dateRange: RangeFilter;
}

const MonthlyTableRow = ({
  node,
  level,
  keyPath,
  expanded,
  toggle,
  renderRow,
  clientId,
  connectionId,
  dateRange,
}: Props) => {
  const key = keyPath.join("-");
  const isExpandable =
    node.children && node.children.length > 0 && !node.header;
  const isExpanded = expanded[key];
  const { formatNumber } = useCurrency();

  const [showModal, setShowModal] = useState(false);
  const [selectedNode, setSelectedNode] = useState<any | null>(null);
  const fetchEnabled = showModal && !!selectedNode?.key;
  //   const rangeKey = `${dateRange.from.year}-${dateRange.from.month}:${dateRange.to.year}-${dateRange.to.month}`;

  const isClickable = isExpandable || (level >= 2 && node.totalCost != 0);

  const levelStyles = {
    0:
      node.children && node.children.length > 0
        ? "pl-4 text-lg font-medium"
        : "pl-4 text-lg font-bold",
    1: "pl-6 text-base",
    2: "pl-10 text-sm",
    3: "pl-14 text-xs",
  } as const;
  const indentClass =
    levelStyles[level as keyof typeof levelStyles] ?? "pl-14 text-xs";

  const handleClick = () => {
    if (isExpandable) {
      toggle(key);
    } else if (isClickable) {
      setSelectedNode(node);
      setShowModal(true);
    }
  };

  console.log("ahhh " + dateRange);
  const { data: voucherData } = useProfitAndLossVoucherRowsRange(
    clientId,
    connectionId,
    dateRange,
    fetchEnabled,
    selectedNode?.key
  );

  function getBodyTableNumbers(level: number, children: any, keyProp?: string) {
    const BodyComponent =
      level === 0 ? Body0 : level === 1 ? Body1 : Body1Muted;
    return (
      <BodyComponent
        key={keyProp}
        className={`text-right px-2 py-2 ${level === 0 ? "pl-4" : "pl-6"}`}
        as="td"
      >
        {children}
      </BodyComponent>
    );
  }

  const rowLabel = level >= 2 ? `${node.key} - ${node.name ?? ""}` : node.name;

  const monthValues: number[] = node.monthlyTotal || node.monthly || [];
  const colSpan = 1 + monthValues.length + 1;

  return (
    <>
      <tr
        className={`border-b hover:bg-gray-50 ${
          isClickable ? "cursor-pointer" : ""
        }`}
        onClick={handleClick}
      >
        <td className={`whitespace-nowrap px-4 py-2 ${indentClass}`}>
          {isExpandable ? (
            <FoldOutButton
              isExpanded={isExpanded}
              toggle={toggle}
              keyValue={key}
            />
          ) : (
            <span className="mr-0 inline-block w-4" />
          )}
          {rowLabel}
        </td>

        {monthValues.map((val: number, idx: number) =>
          getBodyTableNumbers(level, formatNumber(val), `${key}-m-${idx}`)
        )}

        {getBodyTableNumbers(
          level,
          formatNumber(node.totalCost),
          `${key}-total`
        )}
      </tr>

      {isExpanded &&
        node.children?.map((child: any, index: number) =>
          renderRow(child, level + 1, [...keyPath, index])
        )}

      {showModal && selectedNode && (
        <tr>
          <td colSpan={colSpan}>
            <Modal
              onClose={() => setShowModal(false)}
              title={`${selectedNode.key} - ${selectedNode.name}`}
            >
              <ProfitAndLossRawData data={voucherData} showTitle={false} />
            </Modal>
          </td>
        </tr>
      )}
    </>
  );
};

export default MonthlyTableRow;
